module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    }
  }, [_c('ul', {
    staticClass: "headermenu"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'dashboard.index'
      },
      "exact": ""
    }
  }, [_c('a', [_vm._v("Helt Opplagt")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('cc-spinner')], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "app-navbar-collapse"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_vm._v("\n           \n      ")]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [(_vm.hasModuleContracts) ? _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'contractlist'
      },
      "exact": ""
    }
  }, [_c('a', [_vm._v("Nettmeny")])]) : _vm._e(), _vm._v(" "), (_vm.hasModuleCatering) ? _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'catering'
      },
      "exact": ""
    }
  }, [_c('a', [_vm._v("Catering")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.currentUser.name) + " " + _vm._s(_vm.currentUser.customernumber) + " "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [(_vm.isAdmin) ? [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cog",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Administrasjon\n                ")])], 1)] : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Logg ut\n              ")])])], 2)])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#app-navbar-collapse"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Vis meny")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-phone",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:02346"
    }
  }, [_vm._v(" 0 23 46")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ad5648a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/root/navbar.vue
// module id = 905
// module chunks = 16